/**
 * Created by Andrey Popov on 12/2/20.
 */

const ChatHeader = cc.Scale9Sprite.extend({
    ctor: function (chat) {
        this._super(bundles.chat.frames.panelup);

        this.setAnchorPoint(0, 1);
        const styles = cleverapps.styles.ChatHeader;

        const titleText = cleverapps.UI.generateOnlyText(Messages.get("ChatTitle"), cleverapps.styles.FONTS.CHAT_HEADER_TEXT);

        chat.closing = false;

        const backButton = this.backButton = new cleverapps.UI.Button({
            noBg: true,
            content: new cc.Sprite(bundles.chat.frames.icon_back),
            onClicked: function () {
                chat.closing = true;
                // delay end editing adaptation to ensure virtual keyboard is disappeared
                setTimeout(() => {
                    cleverapps.Scenes.GetRunningScene().sceneComponent.closeAction();
                }, connector.info.isMobile && chat.editingMode ? 500 : 100);
            },
            width: styles.back.width,
            height: styles.back.height
        });

        titleText.setPosition(0, styles.text.offsetY);

        this.content = new cleverapps.Layout([backButton, titleText], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.back.margin
        });

        this.addChild(this.content);
        
        this.onResize();
    },

    onResize: function () {
        const styles = cleverapps.styles.ChatHeader;

        this.setContentSize2(cleverapps.resolution.getSceneSize().width, styles.height);
        this.setPosition(0, cleverapps.resolution.getSceneSize().height);

        this.content.setAlignment(this.width / 2 + styles.content.offsetX, this.height / 2);
        cleverapps.UI.fitToBox(this.content, { width: 0.8 * cleverapps.resolution.getSceneSize().width, height: styles.height });
        this.backButton.setScale(1 / this.content.scale);
    }
});

cleverapps.styles.ChatHeader = {
    height: 130,

    content: {
        offsetX: -50
    },

    text: {
        offsetY: -3
    },

    back: {
        width: 120,
        height: 120,

        margin: 25
    }
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    CHAT_HEADER_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.BLACK
    }
});